import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../services/api';

const CurrencyContext = createContext();

export const useCurrency = () => useContext(CurrencyContext);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'USD');
  const [exchangeRate, setExchangeRate] = useState(89500); // Default fallback

  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/settings/exchange-rate`);
        if (response.data.success) {
          setExchangeRate(response.data.data.usdToLbpRate);
        }
      } catch (error) {
        console.error('Failed to fetch exchange rate:', error);
      }
    };

    fetchExchangeRate();
    
    // Refresh rate every 5 minutes if needed
    const interval = setInterval(fetchExchangeRate, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleCurrency = () => {
    const newCurrency = currency === 'USD' ? 'LBP' : 'USD';
    setCurrency(newCurrency);
    localStorage.setItem('currency', newCurrency);
  };

  const formatPrice = (priceInUsd) => {
    if (currency === 'LBP') {
      const amount = Math.round(priceInUsd * exchangeRate);
      return `${amount.toLocaleString()} LBP`;
    }
    return `$${Number(priceInUsd).toFixed(2)}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, exchangeRate, toggleCurrency, formatPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
};